import type { SchoolId } from './types.js';

export interface SchoolInfo {
  id: SchoolId;
  name: string;
  short: string;
  aliases: string[];
}

/** 松江七校（+其他）。id 稳定，中文名只用于展示与解析。 */
export const SCHOOLS: SchoolInfo[] = [
  { id: 'lixin', name: '上海立信会计金融学院', short: '立信', aliases: ['立信', '上海立信', '立信会计', 'lixin'] },
  { id: 'shisu', name: '上海外国语大学', short: '上外', aliases: ['上外', '外国语', 'shisu', 'sisu'] },
  { id: 'donghua', name: '东华大学', short: '东华', aliases: ['东华', 'donghua', 'dhu'] },
  { id: 'huazheng', name: '华东政法大学', short: '华政', aliases: ['华政', '华东政法', 'ecupl'] },
  { id: 'suibe', name: '上海对外经贸大学', short: '外贸', aliases: ['外贸', '对外经贸', 'suibe'] },
  { id: 'sues', name: '上海工程技术大学', short: '工程大', aliases: ['工程大', '工程技术', 'sues'] },
  { id: 'siva', name: '上海视觉艺术学院', short: '视觉', aliases: ['视觉', '视觉艺术', 'siva'] },
  { id: 'other', name: '其他高校', short: '其他', aliases: ['其他', '外校'] },
];

export const SCHOOL_MAP: Record<SchoolId, SchoolInfo> = SCHOOLS.reduce(
  (acc, s) => {
    acc[s.id] = s;
    return acc;
  },
  {} as Record<SchoolId, SchoolInfo>,
);

export function schoolName(id: SchoolId): string {
  return SCHOOL_MAP[id]?.name ?? '未知学校';
}

export function schoolShort(id: SchoolId): string {
  return SCHOOL_MAP[id]?.short ?? '未知';
}

/** 从自由文本里识别学校（长别名优先，避免"上海对外经贸"被"上海"截断） */
export function detectSchool(text: string): SchoolId | null {
  const t = text.toLowerCase();
  const sorted = [...SCHOOLS].sort((a, b) => {
    const la = Math.max(...a.aliases.map((x) => x.length));
    const lb = Math.max(...b.aliases.map((x) => x.length));
    return lb - la;
  });
  for (const s of sorted) {
    if (s.aliases.some((a) => t.includes(a.toLowerCase()))) return s.id;
  }
  return null;
}